var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 123.8 35.5",
    style: {
      enableBackground: "new 0 0 123.8 35.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#DD4C6A;}\n\t.st2{fill:#DD6B7C;}\n\t.st3{fill:url(#SVGID_00000135672058153659196630000016288242456015325631_);}\n\t.st4{fill:url(#SVGID_00000012444112161616220830000013910454310432566938_);}\n\t.st5{fill:url(#SVGID_00000091704167117608678140000012569858690478811783_);}\n\t.st6{fill:#4E1B3D;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{opacity:0.6;fill:#D177B8;enable-background:new    ;}\n\t.st9{fill:url(#SVGID_00000173868200200791705960000018319623164625807251_);}\n\t.st10{fill:url(#SVGID_00000097489872075227425160000013372548999194903951_);}\n\t.st11{fill:url(#SVGID_00000167358291980655084700000015273022664100722850_);}\n\t.st12{fill:url(#SVGID_00000097460145733917468680000003141968178816388998_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.4254,
    y1: 236.5624,
    x2: 176.4254,
    y2: 269.1692,
    gradientTransform: "matrix(0.9486 0.3164 0.3164 -0.9486 -143.3487 203.2354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.4,26.6c-0.2,3.2,18.1,11.1,27.9,7.5c10.5-3.8,16.8-20.4,6.6-26.9C107.7,0.6,85.1,3.4,83.4,26.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.1,14c0,0,8.7-16.4,23-13.7C122.9,2.7,123,15.1,123,15.1S111-11.7,87.1,14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.6,23.5c0,0,1.3,4.2,2.4,6c0,0-3.4-1.5-3.5-2.6C82.4,25.6,83.6,23.5,83.6,23.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.3,32c0,0,10.9,2.1,20.7-1.1c8.3-2.7,10.1-8.3,10.1-8.3s-1.3,7.9-10.4,11.7S91.3,32,91.3,32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020396247375604113480000014252966493095103644_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.7061,
    y1: 243.1603,
    x2: 174.7061,
    y2: 267.323,
    gradientTransform: "matrix(0.9486 0.3164 0.3164 -0.9486 -143.3487 203.2354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#72791A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#594A0B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020396247375604113480000014252966493095103644_)"
    },
    d: "M114.6,20.2c-2.1,6.3-9,9.8-15.3,7.6 c-6.3-2.1-9.8-9-7.6-15.3c2.1-6.3,9-9.8,15.3-7.6C113.3,7,116.7,13.9,114.6,20.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112603989514333044480000017138629578918002587_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.6751,
    y1: 243.8676,
    x2: 174.6751,
    y2: 266.6354,
    gradientTransform: "matrix(0.9486 0.3164 0.3164 -0.9486 -143.3487 203.2354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A68D18"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#402F40"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000112603989514333044480000017138629578918002587_)"
    },
    cx: 103.1,
    cy: 16.4,
    r: 11.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054964042221367426290000009497867019516305574_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.675,
    y1: 247.8525,
    x2: 174.675,
    y2: 262.6253,
    gradientTransform: "matrix(0.9486 0.3164 0.3164 -0.9486 -143.3487 203.2354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#886200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054964042221367426290000009497867019516305574_)"
    },
    d: "M110.1,18.7c-1.3,3.9-5.5,6-9.3,4.7 c-3.9-1.3-6-5.5-4.7-9.3c1.3-3.9,5.5-6,9.3-4.7C109.3,10.7,111.4,14.8,110.1,18.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,19.1c0,0,5.2-14.6,21.7-13.8C123,6,123,18.3,123,18.3s4.4-9.7-7.3-14.3C101.3-1.7,87.9,9.2,84.9,19.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M111.4,17.4c-0.9,0.4,2.2,1.6,4.9,1.4c2.4-0.1,3.8-1.1,3.7-1.4C119.8,17.1,114.8,16,111.4,17.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M109.4,17.4c-0.8-0.6-2-0.5-2.2,0s0.7,1.4,1.3,1.4C109.1,18.8,109.8,17.8,109.4,17.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M84.2,21.4c0,0,8.1-14.2,23-12.4c15,1.7,15.8,10.1,15.8,10.1l0.1-0.7c0,0,1.8-10.3-14.7-14.2 C91.8,0.3,84.8,17.6,84.2,21.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157296185624020748460000009400213060234740884_",
    gradientUnits: "userSpaceOnUse",
    x1: -1275.6191,
    y1: -247.7252,
    x2: -1275.6191,
    y2: -215.1171,
    gradientTransform: "matrix(-0.9486 0.3164 -0.3164 -0.9486 -1263.4507 203.2354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157296185624020748460000009400213060234740884_)"
    },
    d: "M40.5,26.6c0.2,3.2-18.1,11.1-27.9,7.5 C2,30.3-4.3,13.6,5.9,7.1S38.7,3.4,40.5,26.6z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.7,14c0,0-8.7-16.4-23-13.7C1,2.7,0.9,15.1,0.9,15.1S12.8-11.7,36.7,14z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.2,23.5c0,0-1.3,4.2-2.4,6c0,0,3.4-1.5,3.5-2.6C41.4,25.6,40.2,23.5,40.2,23.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.6,32c0,0-10.6,1.6-21.1-1.7c-8.6-2.7-9.7-7.7-9.7-7.7S3,30.5,12.2,34.3C21.3,38.1,32.6,32,32.6,32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054980355194463462050000002292438569873190567_",
    gradientUnits: "userSpaceOnUse",
    x1: -1277.2917,
    y1: -241.1589,
    x2: -1277.2917,
    y2: -216.9962,
    gradientTransform: "matrix(-0.9486 0.3164 -0.3164 -0.9486 -1263.4507 203.2354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#72791A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#594A0B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054980355194463462050000002292438569873190567_)"
    },
    d: "M9.2,20.2c2.1,6.3,9,9.8,15.3,7.6 c6.3-2.1,9.8-9,7.6-15.3s-9-9.8-15.3-7.6C10.6,7,7.1,13.9,9.2,20.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176036427450423066070000001473066105441457545_",
    gradientUnits: "userSpaceOnUse",
    x1: -1277.3228,
    y1: -240.4517,
    x2: -1277.3228,
    y2: -217.6838,
    gradientTransform: "matrix(-0.9486 0.3164 -0.3164 -0.9486 -1263.4507 203.2354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A68D18"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#402F40"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000176036427450423066070000001473066105441457545_)"
    },
    cx: 20.7,
    cy: 16.4,
    r: 11.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085941012930419902110000012337365270025501355_",
    gradientUnits: "userSpaceOnUse",
    x1: -1277.3229,
    y1: -236.4529,
    x2: -1277.3229,
    y2: -221.6801,
    gradientTransform: "matrix(-0.9486 0.3164 -0.3164 -0.9486 -1263.4507 203.2354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#886200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085941012930419902110000012337365270025501355_)"
    },
    d: "M13.7,18.7c1.3,3.9,5.5,6,9.3,4.7 c3.9-1.3,6-5.5,4.7-9.3c-1.3-3.9-5.5-6-9.3-4.7C14.5,10.7,12.4,14.8,13.7,18.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M39,19.1c0,0-5.2-14.6-21.7-13.8C0.9,6,0.8,18.3,0.8,18.3S-3.6,8.7,8.1,4C22.5-1.7,35.9,9.2,39,19.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.5,17.4c0.9,0.4-2.2,1.6-4.9,1.4c-2.4-0.1-3.8-1.1-3.7-1.4C4,17.1,9,16,12.5,17.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M14.5,17.4c0.8-0.6,2-0.5,2.2,0s-0.7,1.4-1.3,1.4C14.8,18.8,14,17.8,14.5,17.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M39.7,21.4c0,0-8.1-14.2-23-12.4C1.7,10.7,0.9,19.1,0.9,19.1l-0.1-0.7C0.8,18.3-1,8,15.5,4.2 C32,0.3,39,17.6,39.7,21.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes2);
export default __webpack_public_path__ + "static/media/Eyes2.7f4008372ffee767450fdd1cd3a003a9.svg";
export { ForwardRef as ReactComponent };